export enum EInterviewFinalResult {
  Pass = 'pass',
  Proceeding = 'proceeding',
  Fail = 'fail',
}

export enum EEmploymentType {
  Newcomer = 'newcomer',
  ExperiencedWorker = 'experienced_worker',
  TransitionalTypeIntern = 'transitional_type_intern',
  GeneralTypeIntern = 'general_type_intern',
}

export enum EInterviewProgress {
  FaceToFace = 'face_to_face',
  Zoom = 'zoom',
  Call = 'call',
}

export enum EInterviewAtmosphere {
  Comfortable = 'comfortable',
  Normal = 'normal',
  Uncomfortable = 'uncomfortable',
}

export enum EInterviewDificultyLevel {
  Easy = 'easy',
  Normal = 'normal',
  Difficulty = 'difficulty',
}
